import { useContext, JSX } from 'react';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import { Handle, Position, useReactFlow, ReactFlowInstance, Node } from "@xyflow/react";
import SettingsIcon from '@mui/icons-material/Settings';
import CheckIcon from "@mui/icons-material/Check";

function WorkflowDataResetNode({id, data}: { id: any, data: any }): JSX.Element {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance: ReactFlowInstance = useReactFlow();

    function handleShowDateResetConfigurationClick(): void {
        let node: Node = reactFlowInstance.getNode(id);
        context.setActiveEditDataResetNode(node);
    }

    function successfulTest(): string {
        let returnValue: string = '';
        if (!!context.testComplete.includes(id)) {
            returnValue = ' test-success'
        }

        if (!!context.testProcessing.includes(id)) {
            returnValue = ' test-processing'
        }

        if (!!context.testErrored.includes(id)) {
            returnValue = ' test-error';
        }

        return returnValue;
    }


    return (
        <div className={ "workflow-node data-reset " + id + " " + (successfulTest())  }>
            { (successfulTest() !== '') &&
                <div className={ successfulTest() + "-icon" } />
            }
            <Handle type="target" id="reset-node-target" position={Position.Top} >
                <span className="handle-label top" >{ "Input" }</span>
            </Handle>
            <div className="node__layout">
                <div className="layout__top">
                    <span className={ "reset-icon" }></span>
                </div>
                <div className="layout__middle">
                    <span className={ "label-span" }>
                        { (typeof data?.label === 'string' && data.label.length > 0) ? data.label : 'Data Reset Node' }
                    </span>
                </div>
                <div className="layout__bottom">
                    <span className="action-span nodrag" onClick={ handleShowDateResetConfigurationClick }>
                        <SettingsIcon />
                    </span>
                </div>
            </div>
            <Handle type="source" id="reset-node-source" position={Position.Bottom} >
                <span className="handle-label bottom" >{ "Output" }</span>
            </Handle>
        </div>
    );
}

export default WorkflowDataResetNode;